import { Typography, styled } from '@material-ui/core';

const Title = styled(Typography)({
  fontSize: 20,
  fontWeight: 'bold',
});

// eslint-disable-next-line import/prefer-default-export
export { Title };
